import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - EOR Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - EOR Container',
        href: '/adm/opr/report/eor-container',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_eor',
    sortDesc: true,
    fields: [
      {
        key: 'code_eor',
        label: 'EOR',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'app_by',
        label: 'App',
      },
      {
        key: 'app_code',
        label: 'App No',
      },
      {
        key: 'total_eor',
        label: 'Total EOR',
      },
      {
        key: 'total_eor_app',
        label: 'Total App',
      },
      {
        key: 'app_status',
        label: 'Status',
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_consignee: '',
      consignee_code: '',
      consignee_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportContEor(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportEORContainer({ commit, state }) {
    commit('reportContEor', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/report/eor-container`, params);
    commit('reportContEor', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportEORContainer({ commit, state }) {
    commit('reportContEor', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/report/eor-container`, params);
    commit('reportContEor', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_container_eor_container.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
